import { Utils } from 'versafleet-core';

const { request, convertDataToParams } = Utils.RequestHelper;

const baseFilter = {
  per_page: 20,
};

function setFilter(filter) {
  return {
    type: 'SET_NOTIFICATION_FILTER',
    filter,
  };
}

function receiveNotifications(result) {
  return {
    type: 'RECEIVE_NOTIFICATIONS',
    notifications: result.notifications,
    meta: result.meta,
  };
}

function receivePanelNotifications(result) {
  return {
    type: 'RECEIVE_PANEL_NOTIFICATIONS',
    panelNotifications: result.notifications,
  };
}

function receiveCount(count) {
  return {
    type: 'RECEIVE_COUNT',
    count,
  };
}

function updateNewNotifications(newNotifications) {
  return {
    type: 'UPDATE_NEW_NOTIFICATIONS',
    newNotifications,
  };
}

function fetchList(filter) {
  return (dispatch, getState) => {
    dispatch(setFilter(filter));
    const state = getState();
    return request(`/notifications${convertDataToParams({
      page: state.notification.notificationMeta.page,
      ...baseFilter,
      ...state.notification.filter,
    })}`, {
      method: 'GET',
    })
      .then((result) => {
        dispatch(receiveNotifications(result));
        return result;
      });
  };
}

function fetchPanelList() {
  return dispatch => request(`/notifications${convertDataToParams({
    per_page: 6,
    page: 1,
    countless: true,
  })}`, {
    method: 'GET',
  })
    .then((result) => {
      dispatch(receivePanelNotifications(result));
      return result;
    });
}

function readNotification(id) {
  return (dispatch, getState) => {
    const state = getState();
    return request(`/notifications/${id}/read`, {
      method: 'PUT',
    })
      .then((result) => {
        const clone = {
          notifications: [...state.notification.notifications],
          meta: state.notification.notificationMeta,
        };
        for (let i = 0; i < clone.notifications.length; i += 1) {
          if (id === clone.notifications[i].id) {
            clone.notifications[i] = {
              ...clone.notifications[i],
              read: true,
            };
            break;
          }
        }
        dispatch(receiveNotifications(clone));
        return result;
      });
  };
}

function readAllNotifications() {
  return (dispatch, getState) => {
    const state = getState();
    return request('/notifications/read_all', {
      method: 'PUT',
    })
      .then((result) => {
        const readNotifications = [...state.notifications].map(notification => (
          { ...notification, read: true }
        ));
        const clone = { notifications: readNotifications };
        dispatch(receiveNotifications(clone));
        return result;
      });
  };
}

function loadNewCount() {
  return dispatch => request('/notifications/new_count', {
    method: 'GET',
  })
    .then((result) => {
      dispatch(receiveCount(result.count));
      return result;
    });
}

function resetNewCount() {
  return dispatch => request('/notifications/update_new_count', {
    method: 'PUT',
  })
    .then((result) => {
      dispatch(receiveCount(0));
      return result;
    });
}

export default {
  fetchList,
  fetchPanelList,
  readNotification,
  readAllNotifications,
  loadNewCount,
  resetNewCount,
  updateNewNotifications,
};
